import { render, staticRenderFns } from "./AbsenceCalendarComponent.vue?vue&type=template&id=be71a752&scoped=true&"
import script from "./AbsenceCalendarComponent.vue?vue&type=script&lang=js&"
export * from "./AbsenceCalendarComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be71a752",
  null
  
)

export default component.exports